var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9m-7-7 7 7m-7-7v7h7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M15.432 17H8.571v-1.335h.502c.243-.014.399-.223.492-.513.093-.288.118-.642.108-.915l-.037-1.076H8.537v-1.335H9.59l-.056-1.759c-.037-1.013.314-1.781.88-2.295S11.758 7 12.57 7l.053 1.316c-.405 0-.801.137-1.096.422-.294.285-.49.722-.49 1.328l.068 1.76h2.288v1.334h-2.238l.038 1.036c.028.577-.073 1.083-.36 1.469h4.599V17Z"
  })));
};
export default SvgInvoice;